import React from 'react';
import { Alert } from 'antd';
import HtmlParser from 'react-html-parser';

/**
 * Hiển thị ghi chú dạng Alert
 *
 * @param {string} note - Nội dung ghi chú (hỗ trợ HTML)
 * @param {string} type - Kiểu cảnh báo (success, info, warning, error)
 * @param {boolean} showIcon - Có hiển thị icon không
 * @param {string} fallbackText - Text hiển thị khi không có ghi chú
 * @param {string} title - Tiêu đề cảnh báo (mặc định: "Ghi chú")
 */
const NoteAlert = ({
    note,
    type = 'info',
    showIcon = true,
    fallbackText = 'Không có ghi chú',
    title = 'Ghi chú',
    ...props
}) => {
    if (!note || note.trim() === '') {
        return null;
    }

    return (
        <Alert
            {...props}
            message={title}
            description={HtmlParser(note)}
            type={type}
            showIcon={showIcon}
        />
    );
};

export default NoteAlert;
